import React from "react";
import IIcon from "../../interfaces/IIcon";

const BeerIcon = (props: IIcon) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
        {...props}
        dangerouslySetInnerHTML={{
            __html: `<path style="fill:#95E7EE;" d="M366.39,125.45L86.5,126v336c0,22.09,17.91,40,40,40h200c22.09,0,40-17.91,40-40V125.65
     L366.39,125.45z"/>
 <polygon style="fill:#FEC652;" points="366.5,462 366.5,125.65 366.39,125.45 86.5,126 86.5,462 "/>
 <path style="fill:#95E7EE;" d="M466.5,211v171c0,22.09-17.91,40-40,40h-60v-40h60V211h-60v-40h60C448.59,171,466.5,188.91,466.5,211
     z"/>
 <path style="fill:#FFE5CB;" d="M385.45,81.71c7.61,33.773-27.227,60.794-59.95,44.15v84.43c0,11.04-8.95,20-20,20s-20-8.96-20-20
     v-40c0-13.81,0.5-39.29-44-39.29c-3.61,0-7.06,1.46-9.56,4.05c-9.09,9.4-21.83,15.24-35.94,15.24c-13.65,0-26.02-5.47-35.04-14.34
     c-3.23-3.17-7.58-4.95-12.32-4.95c-3.81,0-7.29,2.17-8.96,5.59c-9.66,19.78-29.73,33.5-53.18,33.7v79.78
     c-0.5,11.26-9.45,20.22-20.5,20.22s-20.5-8.96-20.5-20c0-13.087,0-106.121,0-120c0-47.57,42.01-85.44,90.76-79.19
     C149.91,26.77,176.03,10,206,10c23.7,0,44.99,10.59,59.64,26.97c6.04-3.82,13.2-5.97,20.86-5.97c17.45,0,32.29,11.17,37.75,26.75
     c8.59-5.76,19.54-8.28,31.09-5.8C370.02,55.09,382.16,67.07,385.45,81.71z"/>
 <path d="M286,451.29c-5.52,0-10,4.48-10,10s4.48,10,10,10s10-4.48,10-10C296,455.77,291.52,451.29,286,451.29z"/>
 <path d="M145.5,200.29c-5.523,0-10,4.477-10,10v191c0,5.523,4.477,10,10,10s10-4.477,10-10v-191
     C155.5,204.767,151.023,200.29,145.5,200.29z"/>
 <path d="M225.5,200.29c-5.523,0-10,4.477-10,10v191c0,5.523,4.477,10,10,10s10-4.477,10-10v-191
     C235.5,204.767,231.023,200.29,225.5,200.29z"/>
 <path d="M126.5,512h200c27.57,0,50-22.43,50-50v-30h50c27.57,0,50-22.43,50-50V211c0-27.57-22.43-50-50-50h-50v-30.259
     c15.675-11.751,23.125-31.613,18.707-51.224c-4.133-18.39-19.313-33.398-37.768-37.345c-9.811-2.105-19.692-1.36-28.695,2.063
     C319.716,30.002,303.862,21,286.5,21c-6.544,0-12.939,1.269-18.852,3.711C250.91,8.922,228.843,0,206,0
     c-30.216,0-58.396,15.393-75.03,40.579C78.7,37.687,35.5,79.156,35.5,130.29v120c0,16.542,13.682,30,30.5,30
     c3.689,0,7.224-0.671,10.5-1.893V462C76.5,489.57,98.93,512,126.5,512z M326.5,492h-200c-13.036,0-24.152-8.361-28.28-20h147.79
     c5.523,0,10-4.477,10-10s-4.477-10-10-10H96.5V250.07v-70.564c22.463-3.391,41.914-17.538,52.14-38.505
     c2.086,0,3.924,0.722,5.309,2.081c11.286,11.098,26.22,17.209,42.051,17.209c16.408,0,31.725-6.495,43.135-18.295
     c0.61-0.632,1.473-0.995,2.365-0.995c15.567,0,25.753,3.325,30.277,9.881c3.729,5.405,3.726,12.915,3.723,18.95v40.459
     c0,13.036,8.361,24.152,20,28.28v162.72c0,5.523,4.477,10,10,10s10-4.477,10-10V238.57c11.639-4.128,20-15.243,20-28.28v-70.464
     c7.005,1.398,14.154,1.407,21,0.007V452h-30.51c-5.523,0-10,4.477-10,10s4.477,9.9,10,9.9h28.79
     C350.652,483.539,339.536,492,326.5,492z M376.5,221h40v151h-40V221z M426.5,181c16.542,0,30,13.458,30,30v171
     c0,16.542-13.458,30-30,30h-50v-20h50c5.523,0,10-4.477,10-10V211c0-5.523-4.477-10-10-10h-50v-20H426.5z M66,260.29
     c-5.691,0-10.5-4.58-10.5-10v-120c0-38.596,31.582-69.852,70.407-69.852c3.017,0,6.05,0.192,9.081,0.581
     c4.045,0.519,7.998-1.471,9.993-5.026C157.437,33.792,180.818,20,206,20c19.73,0,38.752,8.615,52.187,23.637
     c3.256,3.642,8.668,4.398,12.799,1.785C275.559,42.529,280.924,41,286.5,41c12.73,0,24.108,8.061,28.313,20.057
     c1.023,2.92,3.341,5.203,6.277,6.181c2.935,0.978,6.159,0.542,8.729-1.182c6.816-4.57,15.134-6.107,23.429-4.327
     c10.8,2.31,20.03,11.428,22.446,22.179c5.692,25.264-20.205,45.988-45.661,33.039c-3.1-1.577-6.796-1.43-9.762,0.389
     c-2.965,1.818-4.772,5.046-4.772,8.524v84.43c0,5.514-4.486,10-10,10s-10-4.486-10-10v-40.452
     c0.003-7.876,0.008-19.779-7.261-30.315C279.759,127.232,264.034,121,241.5,121c-6.29,0-12.396,2.589-16.749,7.099
     c-7.602,7.862-17.813,12.191-28.751,12.191c-10.553,0-20.507-4.073-28.035-11.477c-5.133-5.039-11.996-7.813-19.325-7.813
     c-7.579,0-14.623,4.397-17.946,11.202c-8.382,17.164-25.35,27.927-44.28,28.089c-5.489,0.047-9.915,4.51-9.915,10v79.525
     C76.147,255.705,71.568,260.29,66,260.29z"/>`,
        }}
    ></svg>
);

export default BeerIcon;
